import { getMarket } from '@pb/utils'

export const getArticlesPath = (articleIds): string =>
  `/pra/articles/v2/byids?id=${articleIds.join('&id=')}`

export const getRecommendationPath = (userBpid: string): string => {
  const contextId = '1300'
  const customerId = userBpid
  const countryCode = getMarket('lowerCase')

  return `${process.env.MYACCOUNT_RECOMMENDATION_ENDPOINT}/getdata/?contextid=[${contextId}]&id=${customerId}&market=${countryCode}&apiKey=${process.env.MYACCOUNT_RECOMMENDATION_API_KEY}`
}

export const numOfItemsPerSlide = {
  xsmall: 2,
  small: 2,
  medium: 2,
  large: 4,
  xlarge: 4,
  xxl: 4,
}
